<div class="w-100">
  <ey-froala-content-wrapper [editorContent]="hintHtml"></ey-froala-content-wrapper>
</div>
